export default {
  me: ['me'],
  permissions: (appName = 'cms') => ['me', 'permissions', `${appName}`],
  userInfo: ['userInfo'],
};
